import React from 'react';
import * as _ from 'lodash';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormDropdownClearButton } from '../../CommonFormComponents';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';

/**
 * 立場ドロップダウンリスト
 *
 * @export
 * @class PositionDropdown
 * @extends {React.Component}
 * @param title {string} 表示名
 * @param placeholder {string} プレースホルダー名
 * @param value {string} 初期値
 * @param options {object} オプションリスト
 * @param setIdentifier {any} setファンクションで選択したデータを識別するための値 (必須ではない)
 * @param set {function} 値選択処理
 */
export class PositionDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allLoaded: false,
      opened: false,
      condition: {
        name: '',
      },
      optionsAll: props.options || [], // 項目全体リスト
      options: props.options || [], // 選択項目リスト
      selected: null, // 選択立場コード
      temporarySelected: null, // 選択立場コードtemp
      isLoading: !props.options, // ロード中フラグ
      disabled: props.disabled || false, //非活性フラグ
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    this.setState({
      isLoading: false,
      loaded: this.props.loaded || false,
      selected: this.props.value,
    });
  }

  // コンポーネントがアンマウントされたときは
  // documentのイベントを除去
  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  // componentWillReceivePropsの使用は非推奨
  // +reactの17バージョン以降廃止の予定なので、
  // 代替処理としてgetDerivedStateFromPropsを使う。
  static getDerivedStateFromProps(nextProps, prevState) {
    let resultState = {};
    // 親コンポーネントから配列(option)の情報が渡ってきているか
    if (
      nextProps.loaded === true &&
      (!_.isUndefined(nextProps.options) &&
        !_.isEqual(nextProps.options, prevState.options))
    ) {
      resultState.options = nextProps.options;
      resultState.loaded = nextProps.loaded;
      resultState.isLoading = false;
    }
    resultState.disabled = nextProps.disabled || false;
    // 初期値が設定されていた場合はselectedへセット
    if (nextProps.value !== prevState.selected) {
      resultState.selected = nextProps.value || null;
      resultState.temporarySelected = nextProps.value || null;
    }
    return resultState;
  }

  componentDidUpdate() {
    if (this.state.opened === true) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };

  handleOpen = e => {
    // 初期化
    let { opened, selected, disabled } = { ...this.state };
    if (opened === false && disabled === false) {
      const targetPosition = _.isFunction(this.props.jumpToShowDropdown)
        ? e.target.getBoundingClientRect()
        : null;
      // プルダウンを表示した際、temporarySelectedに選択済みのidを入れる
      this.setState(
        {
          opened: true,
          temporarySelected: selected,
        },
        () => {
          if (_.isFunction(this.props.jumpToShowDropdown)) {
            this.props.jumpToShowDropdown(targetPosition, 71); // jumpToShowDropdownに選択したドロップダウンの位置情報と立場ドロップダウンの起点を与えてスクロール位置を指定する
          }
        }
      );
    } else {
      this.setState({ opened: false });
    }
  };

  setCondition = e => {
    const name = e.target.value;
    this.setState(
      prevState => ({
        condition: { ...prevState.condition, name },
      }),
      () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          this.search();
        }, 1000);
      }
    );
  };

  search = () => {
    const searchList = this.state.optionsAll.filter(item => {
      return item.position_name.search(this.state.condition.name) !== -1;
    });
    this.setState({ options: searchList });
  };

  /**
   * 指定した立場を選択状態にする
   *
   * @param {number}positionCode：立場コード
   * */
  handleSelectedRow = positionCode => {
    this.setState(
      {
        temporarySelected: positionCode,
      },
      () => {
        this.setValue();
      }
    );
  };

  clearSelectedRow = () => {
    this.setState(
      {
        temporarySelected: null,
      },
      () => {
        this.setValue();
      }
    );
  };

  setValue = () => {
    let { selected } = { ...this.state };
    // temp情報をselect~に入れる
    selected = this.state.temporarySelected;
    this.setState({
      selected,
      opened: false,
    });
    this.props.set(selected, this.props.setIdentifier);
  };

  render() {
    const scrollFrameHeight = document.getElementById(
      'job-and-position-scroll-frame'
    ).clientHeight;

    const getName = () => {
      let name = `${this.props.title}を選択`;
      const option = _.find(this.state.optionsAll, {
        position_code: this.state.selected,
      });
      if (option) {
        name = option.position_name;
      }
      return name;
    };

    return (
      <div className='position__element'>
        <div
          id='form-dropdown'
          className='edit-dialog-modal-dropdown dropdown-multi-select'
        >
          {
            <div ref={this.parent}>
              <div className='dropdown-multi-select__header' >
                <div
                  id='form-dropdown-btn'
                  className={
                    this.state.disabled
                      ? 'dropdown-select disabled'
                      : 'dropdown-select'
                  }
                  onClick={this.handleOpen}
                >
                  <span
                    className={
                      this.state.disabled
                        ? 'dropdown-select__txt disabled'
                        : 'dropdown-select__txt'
                    }
                  >
                    {getName()}
                  </span>
                </div>
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='modal-dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--wide dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        defaultValue={this.state.condition.name}
                        onChange={this.setCondition}
                      />
                    </div>
                    {this.props.isOptional && (
                      <div className='dropdown-single-select__item'>
                        <FormDropdownClearButton
                          onClick={this.clearSelectedRow}
                        />
                      </div>
                    )}
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                        style={{ height: scrollFrameHeight - 184 }} // 計算結果がドロップダウンの高さ（ドロップダウン位置から枠内終端付近まで）
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <SelectableOption
                              key={index}
                              option={option}
                              checked={
                                this.state.temporarySelected ===
                                option.position_code
                              }
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                            />
                          ))}
                        </ul>
                      </div>
                    </div>
                    {/* <div className='dropdown-single-select__footer'>
                      <button className='btn--sm--stay' onClick={this.setValue}>
                        {messageUtility.getMessage('I-000-091')}
                      </button>
                    </div> */}
                  </div>
                </div>
              )}
            </div>
          }
        </div>
      </div>
    );
  }
}

const SelectableOption = ({ option, checked, targetId, handleSelectedRow }) => (
  <li className='single-select__item'>
    <label
      className='radio'
      htmlFor={`single-position-code-${option.position_code}-${targetId}`}
    >
      <input
        id={`single-position-code-${option.position_code}-${targetId}`}
        type='radio'
        checked={checked}
        onClick={() => handleSelectedRow(option.position_code)}
      />
      <RadioButtonIcon className='icon--1_6x' />
      <span className='single-select__label'>{option.position_name}</span>
    </label>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/Position.jsx